import { ActionTree } from "vuex";
import {
  DocumentState,
  UploadPayload,
  CountryPayload,
  DocumentPayload,
} from "../types";
import API from "@/axios";

const actions: ActionTree<DocumentState, any> = {
  upload(context, payload: UploadPayload) {
    return API.post("/iddocumentdata/upload/", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateCountry({ commit }, payload: CountryPayload) {
    commit("setCountry", payload);
  },
  updateDocumentType({ commit }, payload: DocumentPayload) {
    commit("setDocumentType", payload.documentType);
  },
};

export default actions;
